"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableSearchBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _utils = require("@design/lib/utils");
var _button = require("@design/ui/button");
var _inputGroup = require("@design/ui/input-group");
var _searchInput = require("@design/ui/search-input");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ExpandableSearchBar = exports.ExpandableSearchBar = function ExpandableSearchBar(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    isExpanded = _ref.isExpanded,
    onExpandedChange = _ref.onExpandedChange,
    className = _ref.className,
    _ref$keepOpenWithValu = _ref.keepOpenWithValue,
    keepOpenWithValue = _ref$keepOpenWithValu === void 0 ? false : _ref$keepOpenWithValu,
    resultsLabel = _ref.resultsLabel;
  var containerRef = (0, _react.useRef)(null);
  var handleBlur = function handleBlur(e) {
    var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.relatedTarget)) return;
    if (keepOpenWithValue && value) return;
    onExpandedChange(false);
  };
  function keepInputFocused(e) {
    if (!(e.target instanceof HTMLInputElement)) e.preventDefault();
  }
  var closeSearchButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupButton, {
    size: "icon-xs",
    "aria-label": "Close search",
    "aria-expanded": true,
    onClick: function onClick() {
      return onExpandedChange(false);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SearchIcon, {})
  });
  var searchField = isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_searchInput.SearchInput, {
    autoFocus: true,
    className: "h-full [&>input]:h-full",
    placeholder: placeholder,
    value: value,
    onValueChange: onChange,
    onBlur: handleBlur,
    searchIcon: closeSearchButton,
    resultsLabel: resultsLabel
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    variant: "ghost",
    size: "icon-sm",
    onClick: function onClick() {
      return onExpandedChange(true);
    },
    "aria-label": "Search",
    "aria-expanded": false,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SearchIcon, {})
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: containerRef,
    onMouseDown: keepInputFocused,
    className: (0, _utils.cn)("flex h-[30px] max-w-[430px] items-center", className),
    "data-sentry-component": "ExpandableSearchBar",
    "data-sentry-source-file": "expandable-search-bar.tsx",
    children: searchField
  });
};